import Tag from 'components/common/tag';
import ProductLink from 'components/products/product-link';
import { AirHandlerProductType } from 'data/types';
import { abbreviateNumber } from 'utils/helpers';

interface AirHandlerCellProps {
  airHandler: AirHandlerProductType | undefined;
}

export default function AirHandlerCell({ airHandler }: AirHandlerCellProps) {
  return airHandler ? (
    <div className='flex flex-col'>
      <span className='whitespace-nowrap'>
        <ProductLink type='air handler' product={airHandler} hoverInfo />
      </span>
      <div className='flex flex-wrap gap-1'>
        <Tag color='default' text={airHandler.type} />
        <Tag color='blue' text={abbreviateNumber(airHandler.coolingBTU)} />
        <Tag color='orange' text={abbreviateNumber(airHandler.heatingBTU)} />
      </div>
    </div>
  ) : (
    <span>N/A</span>
  );
}
